module.exports = {
  DEFAULT_INTERVAL: 20,
};
